import { DropdownOption } from '../models/dropdown.model';
import { LanguageLabels, APP_LOCALES } from '../models/app.settings';

export function getLocaleByLabel(label: LanguageLabels): DropdownOption {
  return APP_LOCALES.find((locale: DropdownOption) => locale.text === label);
}
